module.exports = __webpack_public_path__ + "static/services-a396066ce553b42ac7d225a9e4f41979.jpeg";